import { LOCALE } from '../../common/constants';

export default function parchmentTransformer({ translations = {}, ...parchment }) {
  return {
    ...parchment,
    ...translations[LOCALE],
  };
}
